import { z } from 'zod';
import { requiredString } from '../helpers';
export const MAX_RETRY_DELAY_SECONDS = {
    toolCall: 5,
    postCall: 30
};
export const createWebhook_Webhook_5_ConfigValidator = (isToolCall) => {
    const maxDelay = isToolCall ? MAX_RETRY_DELAY_SECONDS.toolCall : MAX_RETRY_DELAY_SECONDS.postCall;
    return z.object({
        webhookConnectionId: requiredString('Webhook connection is required'),
        url: z.string().optional(),
        path: z.string().optional(),
        requestMethod: z.enum(['GET', 'POST', 'PUT', 'DELETE', 'PATCH']).default('POST'),
        headers: z.record(z.string(), z.string()).optional(),
        payload: z.record(z.string(), z.any()).optional(),
        expectedOutput: z
            .string()
            .optional()
            .refine((val) => {
            if (!val || val === '')
                return true;
            try {
                JSON.parse(val);
                return true;
            }
            catch {
                return false;
            }
        }, {
            error: 'Must be empty string or valid JSON'
        }),
        retryEnabled: z.boolean().optional().default(false),
        maxRetries: z.number().min(1).max(10).optional().default(3),
        retryDelaySeconds: z.number().min(1).max(maxDelay).optional().default(5)
    });
};
// Default export for post-call context
export const Webhook_Webhook_5_ConfigValidator = createWebhook_Webhook_5_ConfigValidator(false);
//# sourceMappingURL=webhook-webhook-5.js.map